import { bizRequest } from "../../bizClient"; // Import the API helper

const createAuth0User = async (newUser) => {
    return await bizRequest(`/api/customers/createAuth0User`, 'POST', { 'Content-Type': 'application/json' }, {
        connection: 'Username-Password-Authentication',
        email: newUser.email,
        family_name: newUser.lastName,
        given_name: newUser.firstName,
        customer_id: newUser.customerId,
        af_admin: newUser.afAdmin,
        roles: newUser.roles
    })
    .then(resp => resp)
    .catch((error) => error);
}

const getAuth0Users = async (customerId) => {
    return await bizRequest(`/api/customers/getAuth0Users/${customerId}`)
    .then(data => data)
    .catch((error) => error);
}

const updateAuth0User = async (user_id, user, oldUser) => {
    return await bizRequest(`/api/customers/updateAuth0User`, 'POST', { 'Content-Type': 'application/json' }, {
        connection: 'Username-Password-Authentication',
        family_name: user.lastName,
        given_name: user.firstName,
        id: user_id,
        email: user.email,
        customer_id: user.customerId,
        af_admin: user.afAdmin,
        roles: user.roles,
        old_user: oldUser,
        is_active: user.isActive
    })
    .then(resp => resp)
    .catch((error) => error);
}

const auth0PasswordReset = async (email) => {
    return await bizRequest(`/api/customers/auth0PasswordReset`, 'POST', { 'Content-Type': 'application/json' }, {
        connection: 'Username-Password-Authentication',
        email
    })
    .then(resp => resp)
    .catch((error) => error);
}

export {
    createAuth0User,
    getAuth0Users,
    updateAuth0User,
    auth0PasswordReset
}
